import { Controller } from 'stimulus'

// Store previous content globally so undo can access it
// This is set once when streaming starts
let streamingStarted = false

export default class extends Controller {
  connect() {
    const field = this.element.dataset.field
    const content = this.element.dataset.content

    console.log('[quickstart-stream] Received update for field:', field)

    // Store previous content on first stream update
    if (!streamingStarted) {
      this.storePreviousContent()
      streamingStarted = true
    }

    // Update the appropriate field
    this.updateField(field, content)
  }

  storePreviousContent() {
    const previousContent = {
      title: '',
      description: '',
      body: ''
    }

    // Store title
    const titleField = document.getElementById('post_title')
    if (titleField) {
      previousContent.title = titleField.value || ''
    }

    // Store description
    const descriptionField = document.getElementById('post_description')
    if (descriptionField) {
      previousContent.description = descriptionField.value || ''
    }

    // Store body
    if (window.tiptapEditor) {
      previousContent.body = window.tiptapEditor.getHTML() || ''
    } else {
      const editorField = document.querySelector('.editable')
      if (editorField) {
        previousContent.body = editorField.innerHTML || ''
      }
    }

    window.quickstartPreviousContent = previousContent
    console.log('[quickstart-stream] Stored previous content for undo')
  }

  updateField(field, content) {
    if (field === 'title') {
      const titleField = document.getElementById('post_title')
      if (titleField) {
        titleField.value = content
        this.triggerFieldResize(titleField)
      }
    } else if (field === 'description') {
      const descriptionField = document.getElementById('post_description')
      if (descriptionField) {
        descriptionField.value = content
        this.triggerFieldResize(descriptionField)
      }
    } else if (field === 'body') {
      if (window.tiptapEditor) {
        window.tiptapEditor.commands.setContent(content)
      } else {
        const editorField = document.querySelector('.editable')
        if (editorField) {
          const MediumEditor = window.MediumEditor
          const editor = MediumEditor ? MediumEditor.getEditorFromElement(editorField) : null
          if (editor) {
            editor.elements[0].innerHTML = content
          } else {
            editorField.innerHTML = content
          }
        }
      }
    }
  }

  triggerFieldResize(field) {
    field.style.height = 'auto'
    field.style.height = field.scrollHeight + 'px'
  }
}

// Reset the streamingStarted flag when the page loads
document.addEventListener('turbo:load', () => {
  streamingStarted = false
})
